import { useMemo } from 'react';
import type { Customer } from '../../../common/graphql/fragments/gql/Customer';
import { useAccount } from '../../settings/hooks/useAccount';

export const useAllIntermodalCustomers = (options?: {
  includeClosedCustomers?: boolean;
}): Customer[] => {
  const settings = useAccount();

  return useMemo(
    () =>
      settings.customers.filter(
        c => (options?.includeClosedCustomers || c.isValid) && c.isIntermodal,
      ),
    [options?.includeClosedCustomers, settings.customers],
  );
};
